/*
 * @Author: guoyuehua guoyuehua@58.com
 * @Date: 2023-07-12 16:58:43
 * @LastEditors: guoyuehua guoyuehua@58.com
 * @LastEditTime: 2023-07-19 16:43:20
 * @FilePath: /credit_loan_pc/views/pages/index/index.js
 * @Description: 首页
 */
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
const rootElement = document.getElementById('J_Main');
ReactDOM.render(<App />, rootElement);



// WEBPACK FOOTER //
// ./views/pages/index/index.js